import request from '@/utils/request' //引入封装好的 axios 请求
// 列表

export function selectAllDataByEnterprise(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectAllDataByEnterprise',
        method: 'post',
        data: data
    })
}

export function getInfomation(data = {}) {
    return request({
        url: '/api/v2/adp/getInfomation',
        method: 'post',
        data: data
    })
}
// flag == 1
export function selectProAbnormalTaxpayerList(data = {}) {
    return request({
        url: '/api/v1/queryData/selectProAbnormalTaxpayerList',
        method: 'post',
        data: data
    })
}
// flag == 2
export function selectProArrearsInfoList(data = {}) {
    return request({
        url: '/api/v1/queryData/selectProArrearsInfoList',
        method: 'post',
        data: data
    })
}
// flag == 3
export function selectProVatPaymentList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProVatPaymentList',
        method: 'post',
        data: data
    })
}
// flag == 4
export function selectProEnterpriseIncomeTaxList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProEnterpriseIncomeTaxList',
        method: 'post',
        data: data
    })
}
// flag == 5
export function selectProSocialInsuranceArrearsList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProSocialInsuranceArrearsList',
        method: 'post',
        data: data
    })
}
// flag == 6
export function selectProCourtHearingInfoList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProCourtHearingInfoList',
        method: 'post',
        data: data
    })
}
// flag == 7
export function selectProCourtDishonestyInfoList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProCourtDishonestyInfoList',
        method: 'post',
        data: data
    })
}
// flag == 8
export function selectProCourtIntellectualPropertyList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProCourtIntellectualPropertyList',
        method: 'post',
        data: data
    })
}
// flag == 9
export function selectProEnterpriseRealEstateList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProEnterpriseRealEstateList',
        method: 'post',
        data: data
    })
}
// flag == 10
export function selectProEnterpriseEstateMortgageList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProEnterpriseEstateMortgageList',
        method: 'post',
        data: data
    })
}
// flag == 11
export function selectProEnterpriseElectricityList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProEnterpriseElectricityList',
        method: 'post',
        data: data
    })
}
// flag == 12
export function selectProEnterpriseElectricityArrearsList(data = {}) {
    return request({
        url: '/api/v1/queryProvinceData/selectProEnterpriseElectricityArrearsList',
        method: 'post',
        data: data
    })
}

